import React, {useEffect, useState} from 'react';

import {Button, Container, Paper, TextField, Typography} from "@material-ui/core";
import {Alert} from "@material-ui/lab";
import useStyles from "../styles/styles";
import {gql} from "apollo-boost";
import getEnvironment from "../utils/getEnvironment";
import {useMutation, useQuery} from "@apollo/react-hooks";
import SetPromoIdConfirmationModal from "../components/PromoId/SetPromoIdConfirmationModal";

const SetPromoId = () => {
    const classes = useStyles();
    const env = getEnvironment();

    const [input, setInput] = useState('1111');
    const [promoId, setPromoId] = useState('');
    const [highestTrafficSourcePromoId, setHighestTrafficSourcePromoId] = useState('');
    const [modalOpen, setModalOpen] = useState(false)


    const {loading: promoIdLoading, error: promoIdError, data: promoIdData, refetch: promoIdRefetch} = useQuery(gql`
        query GetCurrentPromoId {
            getCurrentPromoId {
                value
          }
        }
    `, {
        context: {
            clientName: "kgraphql"
        }
    });

    const {
        loading: highestTrafficSourcePromoIdLoading,
        error: highestTrafficSourcePromoIdError,
        data: highestTrafficSourcePromoIdData,
        refetch: highestTrafficSourcePromoIdRefetch
    } = useQuery(gql`
        query GetNextPromoId {
            getHighestTrafficSourcePromoId {
                value
          }
        }
    `, {
        context: {
            clientName: "kgraphql"
        }
    });

    const [updatePromoId, {
        loading: updatePromoIdLoading,
        error: updatePromoIdError,
        data: updatePromoIdData
    }] = useMutation(gql`
        mutation SetCurrentPromoId($promoId: Int!) {
            setCurrentPromoId(promoId: $promoId)
        }
    `, {
        context: {
            clientName: "kgraphql"
        }
    });

    useEffect(() => {
        if (promoIdData) {
            setPromoId(promoIdData.getCurrentPromoId.value);
            setInput(promoIdData.getCurrentPromoId.value)
        }
    }, [promoIdLoading])

    useEffect(() => {
        if (highestTrafficSourcePromoIdData) {
            setHighestTrafficSourcePromoId(highestTrafficSourcePromoIdData.getHighestTrafficSourcePromoId.value)
        }
    }, [highestTrafficSourcePromoIdLoading])

    useEffect(() => {
        if (!updatePromoIdLoading && updatePromoIdData) {
            window.location.reload();
        }
    }, [updatePromoIdLoading])


    /**
     * Main Return for Component
     */
    return (
        <>
            <Typography variant="h2">
                Set Promo Id Internal Counter
            </Typography>
            {env === "test" ?
                <>
                <Container maxWidth={false}>
                    <Paper className={classes.paper} style={{marginBottom: 0, overflow: 'hidden'}}>
                        <Typography variant="h5" align="center" gutterBottom>
                            Please enter a value to be set as the internal current promo Id used by Traffic Sources
                        </Typography>
                        <Typography variant="subtitle1" align="center" gutterBottom>
                            This should only be used in special cases where the internal counter needs to be adjusted
                            due to actions that change the internal counter.
                        </Typography>
                        <Container maxWidth={'xs'}>
                            <Alert style={{marginTop: "20px", alignItems: "center"}} severity="warning">
                                <p>
                                    Current internal promoId counter is
                                    at <strong>{promoId}</strong>.
                                    <br/>
                                    Current highest traffic source promoId
                                    is <strong>{highestTrafficSourcePromoId}</strong>
                                </p>

                            </Alert>
                            {/*<Alert severity="warning">Current highest traffic source promoId*/}
                            {/*    is {highestTrafficSourcePromoId}</Alert>*/}

                            <TextField style={{marginTop: "20px"}} label="Promo Id" value={input || ''}
                                       onChange={(e) => {
                                           setInput(e.target.value)
                                       }}/>

                            <br/>
                            <Button style={{marginTop: "20px"}} variant="contained" color="primary" onClick={() => {
                                setModalOpen(true)
                            }}>
                                Set New PromoId
                            </Button>
                        </Container>
                    </Paper>
                </Container>
                {
                    modalOpen ?
                        <SetPromoIdConfirmationModal input={input} promoId={promoId}
                                                     highestTrafficSourcePromoId={highestTrafficSourcePromoId}
                                                     closeModal={() => setModalOpen(false)}
                                                     setPromoIdMutation={updatePromoId}/>
                        : null
                }
                </>
                :
                <Typography variant="h3">
                This page is only available via the Test admin
                </Typography>
            }
        </>
    )
};

export default SetPromoId;
